import React from 'react';

const Logo = () => (
  <svg
    width="31"
    height="28"
    viewBox="0 0 31 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.1842 9.91116L22.3239 3.0334C18.421 -0.879423 12.1196 -0.953582 8.12866 2.85278L1.08496 9.90987C2.5301 8.46245 4.87199 8.46288 6.31659 9.91116L8.93305 12.5343L13.1769 8.27965C14.2233 7.23052 15.9071 7.19372 16.9815 8.17515L17.091 8.27965L23.9513 15.1574C25.3963 16.6061 27.7392 16.6061 29.1842 15.1574C30.6292 13.7087 30.6292 11.3599 29.1842 9.91116Z"
      fill="url(#paint0_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.3347 12.5343L12.5174 21.3741C11.0723 22.8228 11.0723 25.1716 12.5174 26.6204C13.9624 28.0691 16.3053 28.0691 17.7503 26.6204L29.1841 15.1574C27.7391 16.6061 25.3962 16.6061 23.9512 15.1574L21.3347 12.5343Z"
      fill="url(#paint1_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.08377 15.1574C-0.361258 13.7087 -0.361258 11.3598 1.08377 9.91112C2.5288 8.46241 4.87166 8.46241 6.31669 9.91112L15.134 18.7509L12.5176 21.3741C11.0726 22.8228 11.0726 25.1716 12.5176 26.6203L1.08377 15.1574Z"
      fill="url(#paint2_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="12.3722"
        y1="16.2515"
        x2="16.6496"
        y2="4.19541"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3448FF" stopOpacity="0.01" />
        <stop offset="1" stopColor="#3448FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="22.2393"
        y1="28.5314"
        x2="31.1981"
        y2="15.8179"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3448FF" />
        <stop offset="1" stopColor="#3448FF" stopOpacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="1.59575"
        y1="20.4439"
        x2="12.3846"
        y2="28.0416"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3448FF" />
        <stop offset="1" stopColor="#3448FF" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

export default Logo;
